export default __webpack_public_path__ + "static/illustartion2-2c272a7de1b02a941a101b6040ac5e53.svg";